import { useState } from "react";

const PREVIEW_ROUTES = [
  ["Beranda", "/"],
  ["Services", "/services"],
  ["Portfolio", "/portfolio"],
  ["Blog", "/blog"],
  ["About", "/about"],
  ["Tim Kerja", "/team"],
  ["Harga & Paket", "/pricing"],
  ["Contact", "/contact"],
];

export default function MobilePreview() {
  const [path, setPath] = useState("/");
  const [frameKey, setFrameKey] = useState(0);

  return (
    <div className="min-h-screen bg-[#e9e9ec] text-neutral-950">
      <header className="sticky top-0 z-10 flex flex-wrap items-center justify-between gap-3 border-b border-black/10 bg-white/95 px-5 py-3 backdrop-blur">
        <div>
          <p className="text-sm font-bold">Digitalis — Preview Mobile</p>
          <p className="text-xs text-neutral-500">Viewport perangkat: 390 × 844 px</p>
        </div>
        <div className="flex items-center gap-2">
          <label htmlFor="preview-route" className="sr-only">Pilih halaman</label>
          <select id="preview-route" value={path} onChange={(event) => setPath(event.target.value)} className="h-10 rounded-full border border-black/15 bg-white px-4 text-sm font-medium outline-none focus:border-black">
            {PREVIEW_ROUTES.map(([label, value]) => <option key={value} value={value}>{label}</option>)}
          </select>
          <button type="button" onClick={() => setFrameKey((key) => key + 1)} className="h-10 rounded-full border border-black/15 bg-white px-4 text-sm font-semibold hover:bg-neutral-100">Muat Ulang</button>
        </div>
      </header>

      <main className="flex min-h-[calc(100vh-73px)] justify-center overflow-auto p-5 md:p-8">
        <div className="h-fit origin-top overflow-hidden rounded-[2rem] border-[8px] border-neutral-950 bg-neutral-950 shadow-2xl max-[479px]:scale-[0.82]">
          <div className="flex h-7 w-[390px] items-center justify-between bg-neutral-950 px-4 text-[10px] font-semibold text-white">
            <span>Digitalis</span><span>390 × 844</span>
          </div>
          <iframe key={`${path}-${frameKey}`} src={path} title={`Preview mobile ${path}`} className="block h-[844px] w-[390px] border-0 bg-white" />
        </div>
      </main>
    </div>
  );
}
